export default "__VITE_ASSET__e3d62701__"